/* eslint-disable react-hooks/exhaustive-deps */
import { Image } from "antd";
import React, { useEffect, useState } from "react";
import { propHasValue } from "../../../../../components/DynamicFormNew/helper";

const ImageUpload = ({
  item,
  inputName,
  withPlaceholder = true,
  data,
  placeholder,
}) => {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    const value = item ? (propHasValue(item[inputName]) ? item[inputName] : placeholder(item, inputName, withPlaceholder))
      : (propHasValue(data[inputName]) ? data[inputName] : placeholder(data, inputName, withPlaceholder));

    setFileList(Array.isArray(value) ? value : (
      value.fileList && Array.isArray(value.fileList) ?
        value.fileList.map(v => v.response ? v.response : v) : []));
  }, []);

  const map = (v, i) => {
    const url = v.url || v.thumbUrl;

    return (
      <Image
        key={`${i}-images-${url}`}
        width={200}
        src={typeof url === 'string' ? url.includes('https://') ? url : `https://${url}` : url}
      />
    );
  };

  return fileList.length ? <div className="image-container">
    {fileList.filter(f => f.url || f.thumbUrl).map(map)}
  </div> : null;
};

export default ImageUpload;
